import { jsx as _jsx } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Pages/components/Schedule.tsx
import React, { useState } from "react";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import "react-big-calendar/lib/css/react-big-calendar.css";
var VesselFinder = function () {
    var chaseListNavigate = useChaseListNavigate();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var BackHandle = function () {
        chaseListNavigate("/");
    };
    var handleIframeLoad = function () {
        setLoading(false);
    };
    var iframeParams = {
        zoom: 14,
        lat: 25.7722570,
        lon: -80.1659469,
        width: "100%25",
        height: 400,
        names: true,
        track: true,
        fleet: false,
        fleet_name: false,
        fleet_hide_old_positions: true,
        clicktoact: true,
        store_pos: true,
        ra: "https%3A%2F%2Fwww.vesselfinder.com%2Fembed"
    };
    var iframeSrc = "https://www.vesselfinder.com/aismap?zoom=".concat(iframeParams.zoom, "&lat=").concat(iframeParams.lat, "&lon=").concat(iframeParams.lon, "&width=").concat(iframeParams.width, "&height=").concat(iframeParams.height, "&names=").concat(iframeParams.names, "&track=").concat(iframeParams.track, "&fleet=").concat(iframeParams.fleet, "&fleet_name=").concat(iframeParams.fleet_name, "&fleet_hide_old_positions=").concat(iframeParams.fleet_hide_old_positions, "&clicktoact=").concat(iframeParams.clicktoact, "&store_pos=").concat(iframeParams.store_pos, "&ra=").concat(iframeParams.ra);
    return (_jsx("div", { children: _jsx("div", { className: "p-4", style: { display: loading ? "block" : "block" }, children: _jsx("div", { style: { overflow: "hidden", height: "600px" }, children: _jsx("iframe", { src: iframeSrc, width: "100%", height: "600px", title: "BB Pilots", frameBorder: "0", onLoad: handleIframeLoad, style: { position: "relative", top: "-20px" } }) }) }) }));
};
export default VesselFinder;
